import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

import type { Notification, NotificationsState, TNotification, TUpdatePayload } from './types';

const initialState: NotificationsState = {
	notifications: [],
};

const slice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		pushMessage: {
			reducer(state, action: PayloadAction<Notification>) {
				state.notifications.push(action.payload);
			},
			prepare(msg: Omit<Notification, 'id' | 'visible' | 'duration'> & TNotification) {
				return {
					payload: {
						...msg,
						id: nanoid(),
						visible: true,
						duration: msg.duration ?? 0, // дефолт
					} as Notification,
				};
			},
		},
		updateMessage: (state, action: PayloadAction<TUpdatePayload>) => {
			const { id, changes } = action.payload;
			const target = state.notifications.find((n) => n.id === id);
			if (target) {
				Object.assign(target, changes); // Immer позволяет "мутацию"
			}
		},
		removeMessage: (state, action: PayloadAction<string>) => ({
			...state,
			notifications: state.notifications.filter((message) => message.id !== action.payload),
		}),
		removeAllMessages: (state) => ({
			...state,
			notifications: [],
		}),
		removeFirstMessage: (state) => ({
			...state,
			notifications: state.notifications.slice(1),
		}),
	},
});

export const { pushMessage, removeMessage, removeAllMessages, removeFirstMessage, updateMessage } =
	slice.actions;

export const notificationsReducer = slice.reducer;
